import { render, staticRenderFns } from "./SinglePage.vue?vue&type=template&id=b6a6c66a&scoped=true&"
import script from "./SinglePage.vue?vue&type=script&lang=js&"
export * from "./SinglePage.vue?vue&type=script&lang=js&"
import style0 from "./SinglePage.vue?vue&type=style&index=0&id=b6a6c66a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a6c66a",
  null
  
)

export default component.exports